import { storageKeys } from '@/config/app';
import { session } from '@/lib/storage';

export type AuthTab = 'login' | 'register';

/**
 * Перехват `?action=` с лендинга. Выполняется синхронно до первого рендера:
 * `register | login` задают вкладку экрана входа (AUTH-8), `subscribe&plan=`
 * кладёт намерение в sessionStorage, чтобы оно пережило регистрацию и код
 * (BILL-3; потребитель — шаг 7). Наши параметры вычищаются из адреса, остальные
 * (deep-link `?video=`) остаются.
 */
export function captureUrlActions(href: string = window.location.href): {
  tab: AuthTab | null;
  plan: 'monthly' | 'yearly' | null;
  cleanedUrl: string | null;
} {
  const url = new URL(href);
  const action = url.searchParams.get('action');
  if (!action) return { tab: null, plan: null, cleanedUrl: null };

  let tab: AuthTab | null = null;
  let plan: 'monthly' | 'yearly' | null = null;

  if (action === 'register' || action === 'login') {
    tab = action;
    session.set(storageKeys.authTab, action);
  } else if (action === 'subscribe') {
    const raw = url.searchParams.get('plan');
    if (raw === 'monthly' || raw === 'yearly') {
      plan = raw;
      session.set(storageKeys.pendingPlan, raw);
    }
  }

  url.searchParams.delete('action');
  url.searchParams.delete('plan');
  const cleanedUrl = url.pathname + (url.search ? url.search : '') + url.hash;
  return { tab, plan, cleanedUrl };
}

export function applyUrlActions(): void {
  const { cleanedUrl } = captureUrlActions();
  if (cleanedUrl !== null) window.history.replaceState(window.history.state, '', cleanedUrl);
}

/** Вкладка по умолчанию, заданная ссылкой. Чтение без побочных эффектов — годится для инициализатора state. */
export function readInitialAuthTab(): AuthTab | null {
  const stored = session.get(storageKeys.authTab);
  return stored === 'login' || stored === 'register' ? stored : null;
}

/** Флаг одноразовый: чистится после первого показа экрана входа. */
export function clearInitialAuthTab(): void {
  session.remove(storageKeys.authTab);
}

/** Вкладка входа для следующего показа экрана авторизации (CTA публичного канваса). */
export function setInitialAuthTab(tab: AuthTab): void {
  session.set(storageKeys.authTab, tab);
}
